var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoPlayer",staticClass:"video-js",staticStyle:{"width":"100%"},attrs:{"controls":false,"id":`videoStream${_vm.playerId}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }